import * as React from 'react';

import type {UserContentSubscription} from 'src/types/content-subscription';

import {Button} from 'src/components/lib/new-button';
import Success from './success';
import DebugEntityMessage from './debug-entity-message';

import css from './style.css';


type Props = {
  success: boolean;
  isDebugEntity: boolean;
  category: UserContentSubscription;
  alreadyUnsubscribed: boolean;
  onUnsubscribe: () => unknown;
  redirectLink: string;
};

const UnsubscribeComponent = ({
  success,
  isDebugEntity,
  category,
  alreadyUnsubscribed,
  onUnsubscribe,
  redirectLink,
}: Props) => {
  if (success) {
    return <Success />;
  } else if (isDebugEntity) {
    return (
      <div>
        <DebugEntityMessage />
      </div>
    );
  } else if (category) {
    return (
      <div className={css.unsubscribePage}>
        <h2 className={css.questionText}>
          {alreadyUnsubscribed
            ? `You have already unsubscribed from ‘${category.name}’ content category`
            : `Are you sure, you want to unsubscribe from ‘${category.name}’ category emails ?`}
        </h2>

        {!alreadyUnsubscribed && (
          <Button
            className={css.unsubscribeButton}
            type="primary"
            size="large"
            onClick={onUnsubscribe}
          >
            Yes, Unsubscribe
          </Button>
        )}
        <p className={css.footerText}>
          You can manage subscriptions for all content categories
          <a href={redirectLink} className={css.link}>
            here
          </a>
        </p>
      </div>
    );
  } else {
    return null;
  }
};

export default UnsubscribeComponent;
